import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { motion, AnimatePresence } from 'framer-motion';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'About', href: '/about' },
  { name: 'Services', href: '/services' },
  // { name: 'Portfolio', href: '/portfolio' },
  // { name: 'Pricing', href: '/pricing' },
  { name: 'Process', href: '/process' },
  { name: 'Blog', href: '/blog' },
  { name: 'Contact', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'py-3' : 'py-4'
        }`}
      >
        <div className="container-custom">
          <div
            className={`glass rounded-full px-8 py-4 flex items-center justify-between ${
              scrolled ? 'shadow-2xl' : ''
            }`}
          >
            <Link to="/" className="flex items-center flex-shrink-0" data-testid="navbar-logo">
              <div className="bg-white/95 px-4 rounded-xl flex items-center">
                <img
                  src={`${process.env.PUBLIC_URL}/futurePathlogo.png`}
                  alt="FuturePath Technologies"
                  className="h-10 w-auto object-contain"
                  style={{ maxWidth: '200px' }}
                />
              </div>
            </Link>

            <div className="hidden lg:flex items-center gap-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  data-testid={`nav-${item.name.toLowerCase()}`}
                  className={`text-sm font-medium transition-colors hover:text-primary ${
                    location.pathname === item.href
                      ? 'text-primary'
                      : 'text-muted-foreground'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>

            <div className="hidden lg:flex items-center gap-4">
              <Button
                asChild
                className="rounded-full bg-primary hover:bg-primary/90 neon-glow"
                data-testid="nav-consultation-btn"
              >
                <Link to="/consultation">Get Free Consultation</Link>
              </Button>
            </div>

            <button
              className="lg:hidden text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ type: 'tween' }}
            className="fixed inset-0 z-40 lg:hidden"
          >
            <div className="fixed inset-0 bg-black/80 backdrop-blur-xl">
              <div className="fixed right-0 top-0 h-full w-full max-w-sm glass p-6 pt-24">
                <div className="flex flex-col gap-4">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setMobileMenuOpen(false)}
                      data-testid={`mobile-nav-${item.name.toLowerCase()}`}
                      className={`text-lg font-medium transition-colors hover:text-primary py-2 ${
                        location.pathname === item.href
                          ? 'text-primary'
                          : 'text-white'
                      }`}
                    >
                      {item.name}
                    </Link>
                  ))}
                  <Button
                    asChild
                    className="rounded-full bg-primary hover:bg-primary/90 neon-glow mt-4"
                    data-testid="mobile-consultation-btn"
                  >
                    <Link to="/consultation" onClick={() => setMobileMenuOpen(false)}>
                      Get Free Consultation
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
